(ns dre.modals.ds-stats.events
  (:require
   [dre.network :as-alias network]
   [day8.re-frame.tracing :refer-macros [fn-traced]]
   [re-frame.core :as rf]
   [superstructor.re-frame.fetch-fx :as-alias fetch-fx]))


(def db-path [:modals :data :ds-stats])


(rf/reg-event-fx
  ::init
  [(rf/path db-path) rf/trim-v]
  (fn-traced
   [{db :db} [source-type]]
   {:db (-> db
            (assoc :type source-type
                   :state :loading
                   :filter nil))
    ::network/request [{:endpoint (case source-type
                                    :who-ictrp
                                    :stats/who-ictrp
                                    :congresses
                                    :stats/congresses
                                    :feeds
                                    :stats/feeds)}
                       {:on-success [::init-success {:source-type source-type}]}]}))

(rf/reg-event-fx
 ::init-success
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [{:keys [::fetch-fx/response :source-type]}]]
  {:db (-> db
           (assoc :state :success)
           (assoc source-type (:body response)))}))

(rf/reg-event-fx
 ::set-filter
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [value]]
  {:db (-> db
           (assoc :filter value))}))
